<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col
                cols="4"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in department name here"
                  append-icon="search"
                  label="Search Department"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-col
                cols="4"
              >
                <v-select
                  v-model="statusFilter"
                  :items="items"
                  item-text="state"
                  item-value="value"
                  label="Department's Status"
                  placeholder="Active / Deleted"
                />
              </v-col>
              <v-col
                cols="2"
                offset-md="2"
              >
                <setup-departments-dialog-create
                  @created="loadDepartments"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="filteredDepartments"
            :loading="tableLoading"
            :search="search"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <span v-if="statusFilter">
                <setup-departments-dialog-edit
                  :department="item"
                  @updated="refreshData"
                />
                <span class="mx-1" />
                <setup-departments-dialog-delete
                  :department="item"
                  @deleted="refreshData"
                />
              </span>
              <span v-else>
                <setup-departments-dialog-restore
                  :department="item"
                  @restored="refreshData"
                />
              </span>
            </template>
          </v-data-table>
        </v-card> 
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupDepartmentsDialogCreate: () => import('@/components/setup/departments/DialogCreate'),
      SetupDepartmentsDialogDelete: () => import('@/components/setup/departments/DialogDelete'),
      SetupDepartmentsDialogRestore: () => import('@/components/setup/departments/DialogRestore'),
      SetupDepartmentsDialogEdit: () => import('@/components/setup/departments/DialogEdit'),
    },
    metaInfo () {
      return {
        title: 'Departments',
      }
    },
    data () {
      return {
        departments: [],
        trashedDepartments: [],
        headers: [
          {
            text: 'Departments',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
          },
        ],

        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredDepartments () {
        return this.statusFilter ? this.departments : this.trashedDepartments
      },
    },
    created () {
      this.refreshData()
    },
    methods: {
      loadDepartments () {
        this.$api.departments().list([], false)
          .then(response => {
            this.departments = response.data
            this.tableLoading = false
          })
      },
      loadTrashedDepartment () {
        this.$api.departments().listTrashed()
          .then(response => {
            this.trashedDepartments = response.data
          })
      },
      refreshData () {
        this.loadDepartments()
        this.loadTrashedDepartment()
      },
    },
  }
</script>
